import React from "react";
import "../App.css";
// import { Button } from "./Button";
import "./HeroSection.css";

function HeroSection() {
  return (
    <div className="hero-container">
      <video src="assets/videos/video-1.mp4" autoPlay loop muted />
      <h1>Caspar Baumeister</h1>
      <p>Personal Development</p>
    </div>
  );
}

export default HeroSection;
